export const MISSING_CAPTCHA = '-19971';
export const INVALID_CAPTCHA = '-19970';
export const EMAIL_EXISTS = '-19995';
export const INVALID_PASSWORD = '-19976';
export const RESET_PASSWORD = '-19973';
